<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :class="`mr-${marginRight}`"
        :size="size"
        :color="color"
        v-bind="attrs"
        v-on="on"
      >
        <v-img v-if="photoUrl" src="photoUrl"></v-img>
        <span v-else class="white--text text-subtitle-2">{{ userInitials }}</span>
      </v-avatar>
      <span v-if="showFullName" class="text-subtitle-2">{{ username }}</span>
    </template>
    <span>{{ username }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: 'UserAvatar',
    props: {
      displayName: String,
      email: String,
      photoUrl: String,
      size: {
        type: Number,
        default: 24
      },
      color: {
        type: String,
        default: 'teal'
      },
      marginRight: {
        type: Number,
        default: 2
      },
      isCurrentUser: {
        type: Boolean,
        default: false
      },
      showFullName: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      username () {
        let res = 'unknown'

        if (this.isCurrentUser) {
          res = 'You'
        } else {
          if (this.displayName) {
            res = this.displayName
          } else if (this.email) {
            const emailName = this.email.split('@')[0]
            res = emailName
          }
        }

        return res
      },
      userInitials () {
        let firstChar = "?"
        let secondChar = ""
        if (this.displayName) {
          firstChar = this.displayName.charAt(0)
          const displayNameWords = this.displayName.split(' ')
          if (displayNameWords && displayNameWords.length > 1) {
            secondChar = displayNameWords[1].charAt(0)
          }
        } else if (this.email) {
          const emailName = this.email.split('@')[0]
          firstChar = emailName.charAt(0)
          const emailWords = emailName.split('.')
          if (emailWords && emailWords.length > 1) {
            secondChar = emailWords[1].charAt(0)
          }
        }

        return `${firstChar}${secondChar}`.toUpperCase()
      }
    }
  }
</script>
